function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoArchitecture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 180,
    height: 180,
    rx: 36,
    fill: "#6B8CAE",
    style: {
      fill: "rgb(107, 140, 174)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 85,
    r: 12,
    fill: "none",
    stroke: "white",
    strokeWidth: 2.5,
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 125,
    r: 9,
    fill: "none",
    stroke: "white",
    strokeWidth: 2.5,
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 130,
    r: 9,
    fill: "none",
    stroke: "white",
    strokeWidth: 2.5,
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 125,
    r: 9,
    fill: "none",
    stroke: "white",
    strokeWidth: 2.5,
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 97,
    x2: 55,
    y2: 116,
    stroke: "white",
    strokeWidth: 2,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 97,
    x2: 100,
    y2: 121,
    stroke: "white",
    strokeWidth: 2,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 97,
    x2: 145,
    y2: 116,
    stroke: "white",
    strokeWidth: 2,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 55,
    r: 8,
    fill: "white",
    opacity: 0.9,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.9,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 63,
    x2: 100,
    y2: 73,
    stroke: "white",
    strokeWidth: 2,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 162,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "white",
    letterSpacing: 1,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 12,
      fontWeight: 700,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "ARCHITECTURE"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoArchitecture);
export default __webpack_public_path__ + "static/media/Logo_architecture.bf64725f8bb2ad6b40b567489cc328c4.svg";
export { ForwardRef as ReactComponent };